import {ScreenSelector} from './components/ScreenSelector'
import Helmet from 'react-helmet';
import './App.css';

function App() {
  return (
    <div className="App">
      <Helmet>
            <title>Kylie's Immersive World | Test link</title>
            <meta name="title" content="Kylie's Immersive World | Test link"/>
            <meta name="description" content=""/>
            <meta property="og:type" content="website"/>
            <meta property="og:url" content="https://kyliecosmetics.goldsheep.co.uk/"/>
            <meta property="og:title" content="Kylie's Immersive World | Test link"/>
            <meta property="og:description" content=""/>
            <meta property="og:image" content=""/>
            <meta property="twitter:card" content="summary_large_image"/>
            <meta property="twitter:url" content="https://kyliecosmetics.goldsheep.co.uk/"/>
            <meta property="twitter:title" content="Kylie's Immersive World | Test link"/>
            <meta property="twitter:description" content=""/>
            <meta property="twitter:image" content=""/>
      </Helmet>
      <ScreenSelector/>
    </div>
  );
}

export default App;
